import Container from "./Container";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import MapWithPlaces from "./MapWithPlaces";

export default function NewPlaces({className}) {
    const {locale} = useRouter();
    const {aboutUs: lang} = localized[locale];

    return (
        <Container
            className={`flex flex-col md:flex-row items-start gap-10 justify-between ${className ? className : ''}`}>
            <div className="flex-1 max-w-[36ch] flex flex-col gap-10 pb-12 xl:pb-0">
                {lang.location.map((paragraph, key) => (
                    <p className="text-sm leading-relaxed"
                       dangerouslySetInnerHTML={{__html: paragraph}}
                       key={`NewPlacesParagraph: ${key}`}
                    />
                ))}
            </div>
            <MapWithPlaces
                className="flex-1 w-[calc(100%+1.5rem)] md:w-full max-w-[600px] -mb-16"
                innerClassName="w-[calc(100%+1.5rem)] md:w-full rounded-lg"
            />
        </Container>
    )
}
